// SOVRANOVA — region-aware PROFESSIONAL-support directories for the Stepped-Care
// "Talk to someone" panel (amber/red). Bundled (no network) so it works offline.
// These point at ongoing professional care (GP / therapist / government services),
// which is distinct from the crisis lifeline (see crisisResources.js).
// Reputable, top-level resources only. URLs verified 23 Jun 2026 — re-check
// periodically (e.g. AU "Head to Health" became Medicare Mental Health in 2024).

const DIRECTORIES = {
  AU: [
    { label: 'Medicare Mental Health — free, no referral', url: 'https://www.medicarementalhealth.gov.au/' },
    { label: 'Beyond Blue — get support', url: 'https://www.beyondblue.org.au/get-support' },
  ],
  US: [
    { label: 'FindTreatment.gov (SAMHSA)', url: 'https://findtreatment.gov/' },
    { label: 'Psychology Today — find a therapist', url: 'https://www.psychologytoday.com/us/therapists' },
  ],
  UK: [
    { label: 'NHS Talking Therapies', url: 'https://www.nhs.uk/tests-and-treatments/talking-therapies/' },
    { label: 'BACP — find a therapist', url: 'https://www.bacp.co.uk/search/Therapists' },
  ],
  NZ: [
    { label: 'Mental Health Foundation NZ — find support', url: 'https://mentalhealth.org.nz/helplines' },
    { label: 'Need to talk? Free call or text 1737', url: 'https://1737.org.nz/' },
  ],
};

// Regions without a verified national directory (IE, CA, EU, XX, unknown) get
// the worldwide helpline directory plus "your doctor or local health service" —
// never another country's services (international beta wave, Sep 2026).
const GLOBAL = [
  { label: 'Find a helpline or support service in your country', url: 'https://findahelpline.com/' },
];
DIRECTORIES.GLOBAL = GLOBAL;

const DEFAULT_REGION = 'GLOBAL';

// Returns an array of { label, url } professional-support directories for the
// region. Falls back to GLOBAL (never a specific country). Pair with
// resolveRegion() from crisisResources.
export function getProfessionalResources(region) {
  return DIRECTORIES[region] || DIRECTORIES[DEFAULT_REGION];
}
